<template>
  <div class="play-base">
    <video-play
      v-if="videoPlayer.codingFormat === 0"
      ref="videoPlay"
      :video-player="videoPlayer"
    ></video-play>
  </div>
</template>
<script>
import VideoPlay from "./VideoPlay.vue";
export default {
  name: "PlayBase",
  props: ["videoPlayer"],
  components: {
    VideoPlay,
  },
  data() {
    return {
      streamLoader: null,
      player: null,
      reconnectTimeout: null,
      currentVideoCodec: 0,
      _videoWidth: 0,
      _videoHeight: 0,
    };
  },
  mounted() {
    var t = this.videoPlayer;
    t.VideoPlay = this;
  },
  methods: {
    muted() {
      this.getPlayer().muted();
    },
    voice() {
      //禁音
      this.getPlayer().voice();
    },
    getPlayer() {
     
      return this.$refs.videoPlay; //后续可以扩展canvas
    },
    load() {
      this.getPlayer().load();
    },
    startRecord() {
      this.getPlayer().startRecord();
    },
    stopRecord() {
      this.getPlayer().stopRecord();
    },

    send(t) {
      return this.getPlayer().send(t);
    },
    getMediaInfo() {
      return this.getPlayer().getMediaInfo();
    },
    setPlayerSize() {
      return this.getPlayer().setPlayerSize();
    },
    destroy: function () {
      var t = this.getPlayer();
      if (t && (t.player || t.flvPlayer)) return t.destroy();
    },
    getCurrentTime: function () {
      var t = this.getPlayer();
      return t && (t.player || t.flvPlayer) ? t.getCurrentTime() : null;
    },
    setCurrentTime: function (t) {
      var e = this.getPlayer();
      if (e && (e.player || e.flvPlayer)) return e.setCurrentTime(t);
    },
    getBuffered: function () {
      var t = this.getPlayer();
      if (t && (t.player || t.flvPlayer)) return t.getBuffered();
    },
    getPlaybackRate: function () {
      return this.getPlayer().getPlaybackRate();
    },
    setPlaybackRate: function (t) {
      return this.getPlayer().setPlaybackRate(t);
    },
    getPaused: function () {
      return this.getPlayer().getPaused();
    },
    pause: function () {
      return this.getPlayer().pause();
    },
    play: function () {
      return this.getPlayer().play();
    },
    isPlaying: function () {
      var t = this.getPlayer();
      return !(!t || (!t.player && !t.flvPlayer)) && t.isPlaying();
    },
    send: function (t) {
      return this.getPlayer().send(t);
    },
  },
};
</script>
